import { Routes } from '@angular/router';
import { MpsLoggedInGuard } from '@mps/guards/mps-loggedin.guard';

/**
 * LAB Routes - Zone Expérimentale
 *
 * Ce fichier centralise toutes les routes des features de test.
 * Ces routes sont accessibles uniquement en développement.
 */
export const LAB_ROUTES: Routes = [
  {
    path: 'lab',
    data: { title: 'LAB' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [MpsLoggedInGuard],
    children: [
      {
        path: 'mps-kit',
        loadChildren: () => import('@lab/mps-kit/lab-mps-kit.routes').then((m) => m.LAB_MPS_KIT_ROUTES),
        data: { title: 'mps-kit' },
        canActivate: [MpsLoggedInGuard],
      },
      {
        path: 'lab_v2',
        loadChildren: () => import('@mps/mps-kit-lab/mps-kit-lab.routes').then((m) => m.MPS_KIT_LAB_ROUTES),
        data: { title: 'lab_v2' },
        canActivate: [MpsLoggedInGuard],
      },
      {
        path: 'features',
        loadChildren: () => import('@lab/features/lab-features.routes').then((m) => m.LAB_FEATURES_ROUTES),
        data: { title: 'features' },
        canActivate: [MpsLoggedInGuard],
      },
    ],
  },
];
